/*
 * SidePanelUploadSingleImage.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 10 2023 mys Company
 */

import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-hot-toast'
import { BASE_URL, getUserId } from '../../config/constant/constants'
import { localization } from '../../config/localize/localizable'
import { useFileHooks } from '../../modules/file/hooks/useFileHooks'
import * as mysUtilities from '../../utilities/mysUtilities'
import imagePlaceHolder from '../../assets/images/imageplaceholder.png'
import audioPlaceHolder from '../../assets/images/audioPlaceholder.png'
import videoPlaceHolder from '../../assets/images/videoPlaceholder.png'

const FileUploaderTopPanelTable = ({ label, sourceId, type, className, uploaded, accepts = 'image/*', multiple = false, itemsCount = 0 }) => {
    //
    //MARK: VARIABLE
    const fileRef = useRef()
    const titleRef = useRef()
    const descRef = useRef()
    const imageRef = useRef()
    const service = useFileHooks()
    let [model, setModel] = useState({})
    let formData = null

    let imgSrc = !mysUtilities.isNullOrEmpty(model.id) ? (model ? BASE_URL + 'v1/files/' + (model?.id ?? 0) + '/s' : imagePlaceHolder) : ''

    //
    //MARK: METHODS

    // onChange File Service

    const handleChange = (e) => {
        let models = []
        let fileCount = e.target.files.length
        formData = new FormData()

        if (fileCount === 1) {
            // a file was selected
            for (let i = 0; i < fileCount; i++) {
                formData.append('attachments', e.target.files[i], e.target.files[i].name)
                var reader = new FileReader()
                reader.readAsDataURL(e.target.files[0])

                var item = {}
                item.title = titleRef.current?.value ?? ''
                item.description = descRef.current?.value ?? ''
                item.userId = getUserId()
                item.default = true
                item.priority = itemsCount + 1
                item.entityName = type
                item.sourceId = sourceId
                models.push(item)

                reader.onload = (event) => {
                    // called once readAsDataURL is completed
                    imageRef.current.src = accepts.includes('image') ? event.target.result : accepts.includes('audio') ? audioPlaceHolder : videoPlaceHolder
                }
            }
            formData.append('jsonString', JSON.stringify(models))
            formData.append('reportProgress', 'true')
            formData.append('multiSize', accepts.includes('image') ? 'true' : 'false')

            fileRef.current.value = null
        }
    }

    // Save File Service

    const handleSave = () => {
        if (!formData) {
            toast.error(localization.MSG_file_isnotchoose)
            return
        }
        service.uploads(formData, {
            onSuccess: (response) => {
                if (response.data.result) {
                    if (uploaded) uploaded(response.data.result.id)
                } else {
                    fileRef.current.value = null
                    imageRef.current.src = null
                }
            },
        })
    }

    return (
        <>
            <div className={`w-full bg-white p-2 shadow rounded-md ${className}`}>
                <input type="file" className="hidden" ref={fileRef} onChange={handleChange} accept={accepts} multiple={multiple} />
                <div className="text-sm font-bold mb-1"> {label}</div>
                <hr className="mb-1" />
                <div className="grid grid-cols-6">
                    <div>
                        <img
                            src={imgSrc}
                            className="w-full h-full rounded shadow"
                            ref={imageRef}
                            alt=""
                            onClick={(e) => fileRef.current.click()}
                            onError={(e) => {
                                e.target.src = imagePlaceHolder
                            }}
                        />
                    </div>
                    <div className="p-2 col-span-4">
                        <div className="block mb-2">
                            <input type="text" ref={titleRef} placeholder={localization.title} className="w-full border border-gray-100 rounded shadow-sm p-2 outline-none" />
                        </div>
                        <div className="block">
                            <input type="text" ref={descRef} placeholder={localization.description} className="w-full border border-gray-100 rounded shadow-sm p-2 outline-none" />
                        </div>
                    </div>
                    <div className="text-left col-span-1">
                        <button className="w-full bg-green-700 p-2 mt-2 left-0  rounded text-white" onClick={handleSave}>
                            + {localization.add}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FileUploaderTopPanelTable
